import { ClientSSO } from './client-sso';

export class LoginResponse {
  token: any = null;
  clientAlias: string = null;
  client: ClientSSO = null;
  userId: string = null;
  userEmail?: string = '';

  preferences: {
    languageId: number;
    mfaMode: number;
  };

  constructor(loginResponse: LoginResponse) {
    Object.assign(this, loginResponse);
  }
}
